import * as React from "react";
import { Link as RouterLink } from "react-router";

import { Goto } from "@/shared/navigation/Goto";

/**
 * Wraps a failure reason in copy that names where to retry. Shared by the callback page and the
 * route's error element so a thrown loader and a returned error read identically to the admin.
 */
export function renderSlackConnectError(reason: React.ReactNode) {
  return (
    <>
      Connecting Slack failed. {reason} Start again from the{" "}
      <RouterLink to={Goto.route.SlackIntegration}>
        Slack integration page
      </RouterLink>
      .
    </>
  );
}
